import Download from "./Download";
import { MimeTypes } from "../types";

export default class DownloadZIP extends Download {
  getMimeType(): string {
    return MimeTypes.ZIP;
  }

  execute(file: Blob, fileName: string): void {
    super.execute(file, fileName);
  }
}
